import { useEffect } from "react";
import classes from "./FormApprovalComplete.module.css";
import { useTranslation } from "react-i18next";
import { useUserContext } from "../../../contexts/UserContext";
import { useCurrentDataContext } from "../../../contexts/CurrentDataContext";

interface Props {
  formSending?: boolean;
  setFormSending?: (val: boolean) => void;
}

const FormApprovalCompleteTop = ({ formSending, setFormSending }: Props) => {
  const { t } = useTranslation();

  // Context for userData
  const { user } = useUserContext();

  // Context for form data
  const { currentData } = useCurrentDataContext();

  useEffect(() => {
    setFormSending && setFormSending(false);
  }, []);

  return (
    <div>
      <div className={classes.formApprovalTitle}>
        {`3 ${t("formApproval.mainTitle")}`}
      </div>
      <div className={classes.innerContainer}>
        <div>{t("formApproval.boss")}</div>
        <div className={classes.approvalTextRow}>
          {user?.firstName + " " + user?.lastName}
        </div>

        <div>{t("formApproval.doctor")}</div>
        <div className={classes.approvalTextRow}>
          <div className={classes.bolded}>
            {currentData?.assignedDoctorFullTitle}
          </div>
          <div>({`${t("formApproval.waitingForApproval")}`})</div>
        </div>
      </div>
    </div>
  );
};

export default FormApprovalCompleteTop;
